export const BOARD_PIC = "BOARD_PIC";
export const ADD_UPLOAD = "ADD_UPLOAD";
export const SET_UPLOADS = "SET_UPLOADS";
export const DELETE_UPLOAD = "DELETE_UPLOAD";
export const DELETE_ALL_UPLOAD = "DELETE_ALL_UPLOAD";
export const DELETE_MULTI_VOICE_UPLOAD = "DELETE_MULTI_VOICE_UPLOAD";
export const GET_TASK_TEMPORARY_GOALS = "GET_TASK_TEMPORARY_GOALS";
export const CHANGE_UPLOAD_WORKED_SCREEN_STATUS =
  "CHANGE_UPLOAD_WORKED_SCREEN_STATUS";
export const USER_DAILY_WORK_REPORTS = "USER_DAILY_WORK_REPORTS";
export const USER_RECENT_WORK_REPORTS = "USER_RECENT_WORK_REPORTS";
export const ADVOCACY_REVIEW_RUNS_SUCCESS = "ADVOCACY_REVIEW_RUNS_SUCCESS";
export const ADVOCACY_REVIEW_DAY_SUCCESS = "ADVOCACY_REVIEW_DAY_SUCCESS";
export const GANTT_TASKS = "GANTT_TASKS";
export const CHANGE_TASKMAP_DATE_GANTT = "CHANGE_TASKMAP_DATE_GANTT";
export const UPDATE_TASKMAP_TASKDETAIL_GANTT =
  "UPDATE_TASKMAP_TASKDETAIL_GANTT";
export const CHANGE_TASK_DATE_GANTT = "CHANGE_TASK_DATE_GANTT";
export const UPDATE_TASK_TASKDETAIL_GANTT = "UPDATE_TASK_TASKDETAIL_GANTT";
export const NEW_TASK_SOCKET = "NEW_TASK_SOCKET";
export const REMOVED_TASK_SOCKET = "REMOVED_TASK_SOCKET";
export const SOCKET_DELETE_TASKMAP = "SOCKET_DELETE_TASKMAP";
export const SOCKET_NEW_TASKMAP = "SOCKET_NEW_TASKMAP";
export const SOCKET_LEAVE_TASKMAP = "SOCKET_LEAVE_TASKMAP";
export const IMPORT_TASKMAPS = "IMPORT_TASKMAPS";
export const OUT_OF_ARCHIVE_TASK = "OUT_OF_ARCHIVE_TASK";
export const ENTER_IN_ARCHIVE_TASK = "ENTER_IN_ARCHIVE_TASK";
export const CHANGE_CURRENT_USER_WORKING_STATUS =
  "CHANGE_CURRENT_USER_WORKING_STATUS";
export const USER_WORKING_STATUS = "USER_WORKING_STATUS";
export const USER_CONNECT_BOARDROOM = "USER_CONNECT_BOARDROOM";
export const USER_LEAVE_BOARDROOM = "USER_LEAVE_BOARDROOM";
export const TASKS_FILTERS_DATA = "TASKS_FILTERS_DATA";
export const SPRINT_FILTERS_DATA = "SPRINT_FILTERS_DATA";
export const TASKS_SHOW_ALL_FILTER = "TASKS_SHOW_ALL_FILTER";
export const TASKS_SHOW_DETAIL_TOGGLE = "TASKS_SHOW_DETAIL_TOGGLE";
export const TASKS_VIEW_MODEL = "TASKS_VIEW_MODEL";
export const TASKS_SEARCH_TEXT = "TASKS_SEARCH_TEXT";
export const REPLACE_VOICE_DESC_IN_TASK = "REPLACE_VOICE_DESC_IN_TASK";
export const REPLACE_DESC_DATA_IN_TASKMAP = "REPLACE_DESC_DATA_IN_TASKMAP";
